<template>
	<a
		@click="bannerClick"
		target="_blank"
		v-if="!isExpired"
		:style="{
			backgroundImage: `url(${unionActivity})`,
		}"
		href="/static/html/joint_product/index.html"
		class="union-activity"
	>
	</a>
</template>
<script>
import { getServerTime, entryDeadline } from '../../../../utils/time'
import unionActivityEn from './union_activity_en.png'
import unionActivity from './union_activity.png'

export default {
	data() {
		return {
			isExpired: true,
		}
	},
	async created() {
		const serverTime = await getServerTime()
		this.isExpired = serverTime > entryDeadline
	},
	computed: {
		unionActivity() {
			return Constants.LOCAL_LANGUAGE === 'en' ? unionActivityEn : unionActivity
		},
	},
	methods: {
		bannerClick() {
			window.teaAnalyticsEvent()
		},
	},
}
</script>
<style lang="scss" scoped>
.union-activity {
	display: block;
	width: 100%;
	height: 60px;
	background-repeat: no-repeat;
	background-position: center center;
	background-size: cover;
}
</style>
